export enum TableDisplayEnum {
    List = "list",
    Card = "image",
}